import styles from './expand.module.scss';
import { styled } from '@mui/material/styles';
import { IconButton } from '../icon-button/icon-button';
import { Icon } from '../icon/icon';

export const ExpandButton = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto'
}));

export const ExpandIcon = styled((props: any) => {
  const { expand, ...other } = props;
  return <Icon {...other} />;
})(({ expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  color: '#fff'
}));

export default ExpandButton;